import React from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import SearchBarContext, { useLockFocus } from './context';

const Icon = styled(animated.span)`
  position: fixed;
  color: ${props => props.theme.secondaryColor};
  line-height: 66px;
  font-weight: 900;
  cursor: pointer;
`;

export default function MagnifyGlassIcon() {
  const {
    state: {
      animation, expanded, width,
    },
    dispatch,
  } = React.useContext(SearchBarContext);

  const { x } = useSpring({
    // eslint-disable-next-line no-nested-ternary
    x: expanded ? (48 - width) : -3,
    immediate: !animation,
  });

  const onClicked = e => {
    e && e.preventDefault();
    dispatch({ type: 'expand', payload: true });
  };

  return (
    <Icon
      className="icon-lw icon-lw-magnifying-glass"
      {...useLockFocus()}
      onClick={onClicked}
      style={{
        transform: x.interpolate(v => `translateX(${v}px)`),
      }}
    />
  );
}
